import React from "react";

const IsValidatePassword = (password) => {
  const passwordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#^])[A-Za-z\d@$!%*?&.#^]{8,}$/;
  return passwordRegex.test(password);
};

export default IsValidatePassword;
